module.exports = __webpack_public_path__ + "static/media/wilfred-peterson.70a5b507.webp";